import React from "react";
import { Mic } from "lucide-react";
import { FEED_TABS } from "../data/constants";

export function TopicHero({ topic }) {
  const title = topic?.title || "Argomento";
  const image = topic?.image || "https://images.unsplash.com/photo-1748194380219-846a1c4bd2f0?w=1400&h=320&fit=crop";
  return (
    <div className="relative h-16 sm:h-[180px]" data-testid="topic-hero-media">
      <img
        src={image}
        alt={title}
        className="w-full h-full object-cover"
        onError={(e) => (e.currentTarget.src = "https://images.unsplash.com/photo-1748194380219-846a1c4bd2f0?w=1400&h=320&fit=crop")}
      />
      <div className="absolute inset-0 bg-gradient-to-r from-black/65 via-black/35 to-black/45" />
      <h1 className="absolute inset-y-0 left-3 right-12 flex items-center font-display font-semibold text-white text-lg leading-tight drop-shadow-lg sm:inset-y-auto sm:bottom-4 sm:left-6 sm:right-20 sm:block sm:text-4xl md:text-5xl" data-testid="topic-hero-title">
        {title}
      </h1>
      <Mic size={28} className="absolute top-1/2 -translate-y-1/2 right-3 text-white/95 drop-shadow-xl sm:right-6 sm:w-[72px] sm:h-[72px]" strokeWidth={1.5} />
    </div>
  );
}

export function FeedTabs({ activeTab, onChange }) {
  return (
    <>
      <div className="px-3 sm:px-6 border-b border-edge flex items-center gap-4 sm:gap-6 overflow-x-auto" data-testid="feed-tabs">
        {FEED_TABS.map((t) => (
          <button
            key={t.key}
            className={`tab ${activeTab === t.key ? "active" : ""}`}
            onClick={() => onChange(t.key)}
            data-testid={`tab-${t.key}`}
          >
            {t.label}
          </button>
        ))}
      </div>
      <p className="px-3 sm:px-6 py-2 text-center text-xs sm:text-sm font-bold text-red-500 whitespace-normal sm:whitespace-nowrap leading-snug">
        Esprimi la tua opinione in totale libertà:<br />
        condividi foto, video e vocali anonimi, con voce originale o alterata e traduzione in tempo reale.
      </p>
    </>
  );
}
